module.exports = __webpack_public_path__ + "static/img/wx-mini.b8484d8f.png";